import { Check } from "lucide-react";
import { eur } from "@/lib/price";

const STEPS = [
  ["proposta_generata", "Generata"], ["proposta_inviata_at", "Inviata"], ["proposta_aperta_at", "Aperta"],
  ["contratto_firmato_at", "Firmata"], ["caparra_pagata_at", "Caparra"],
];
const dt = (d) => (d ? new Date(d).toLocaleDateString("it-IT") : "");

// Avanzamento trattativa + dati commerciali della pratica Chiavi in mano
export function Trattativa({ c, testid }) {
  const t = c.trattativa || {};
  const m = c.commerciale;
  if (!m && !Object.keys(t).length) return null;
  return (
    <div className="mt-2 space-y-2 border-t border-neutral-900 pt-2" data-testid={testid}>
      <div className="flex flex-wrap items-center gap-1">
        {STEPS.map(([k, l], i) => {
          const ok = !!t[k];
          const extra = k === "proposta_aperta_at" && t.proposta_aperture ? ` ×${t.proposta_aperture}` : "";
          return (
            <span key={k} className="flex items-center gap-1">
              {i > 0 && <span className={`h-px w-3 ${ok ? "bg-[#C17F59]" : "bg-neutral-800"}`} />}
              <span title={typeof t[k] === "string" ? dt(t[k]) : ""} data-testid={`${testid}-step-${k}`} data-done={ok ? "1" : "0"}
                className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${ok ? "border-[#C17F59] bg-[#C17F59]/15 text-[#E8B48F]" : "border-neutral-800 text-neutral-600"}`}>
                {ok && <Check className="h-3 w-3" />}{l}{extra}
              </span>
            </span>
          );
        })}
      </div>
      {(m || t.fornitore_attuale) && (
        <div className="flex flex-wrap gap-x-4 gap-y-0.5 text-[11px] text-neutral-400" data-testid={`${testid}-comm`}>
          {m && <span>Prezzo <b className="font-mono text-white">{eur(m.prezzo_iva_incluso)}</b> IVA incl.</span>}
          {m?.potenza_kwp != null && <span>{Number(m.potenza_kwp).toLocaleString("it-IT")} kWp</span>}
          {!!m?.accumulo_kwh && <span>Accumulo {m.accumulo_kwh} kWh</span>}
          {m?.wallbox && <span>{m.wallbox}</span>}
          {m?.pagamento && <span>{m.pagamento}</span>}
          {m?.margine_eur != null && <span data-testid={`${testid}-margine`}>Margine <b className="font-mono text-[#E8B48F]">{eur(m.margine_eur)}</b> · costi {eur(m.totale_costi)}</span>}
          {t.caparra_importo != null && <span>Caparra {eur(t.caparra_importo)}</span>}
          {t.fornitore_attuale && <span data-testid={`${testid}-fornitore`}>Fornitore attuale <b className="text-white">{t.fornitore_attuale}</b></span>}
        </div>
      )}
    </div>
  );
}
